// extracted by mini-css-extract-plugin
module.exports = {"wrap":"RoleUsersList__wrap--2naIc","menuButtons":"RoleUsersList__menuButtons--35D8P","paginator":"RoleUsersList__paginator--3PMjp","formWrap":"RoleUsersList__formWrap--2AEDj"};